import * as React from 'react';
import {ButtonPill} from './button-pill';
import maybe from '../lib/maybe';
import {style} from 'typestyle';
import {percent} from 'csx';
import {SVGIcon} from './svg-icon';
import {colorBrand} from '../theme/color';

type DropdownSelectOption = {
  value: string;
  label: string;
}

type Props = {
  placeholder: string;
  renderLabel?(label: string): string;
  onChange?(value: string): any;
  options: DropdownSelectOption[]
  value: string;
};


export default class DropdownSelect extends React.Component<Props, any> {
  render() {
    const {
      value,
      placeholder,
      options,
      renderLabel = DropdownSelect.renderLabel
    } = this.props;

    const label = maybe(
      () => options.find(o => o.value === value).label,
      '',
    );

    return (
      <span className={DropdownSelect.styles.container}>
        <ButtonPill muted={true}>
          {value ? renderLabel(label) : placeholder}
          <SVGIcon.ArrowRight
            color={colorBrand.toString()}
            className={DropdownSelect.styles.dropdownToggle}
            size={12}
          />
        </ButtonPill>
        <select value={value} onChange={this.handleChange}>
          <option value="">{placeholder}</option>
          {options.map(({value, label}, index) => (
            <option
              key={index}
              value={value}
              children={label}
            />
          ))}
        </select>
      </span>
    )
  }

  handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
    if (this.props.onChange)
      this.props.onChange(event.currentTarget.value);
  };

  static renderLabel = (label: string) => label;

  static styles = {
    container: style({
      flexShrink: 0,
      position: 'relative',
      $nest: {
        '&>*:first-child': {
          zIndex: 0,
          pointerEvents: 'none',
        },
        '&>select': {
          border: 'none',
          background: 'none',
          color: 'transparent',
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: percent(100),
          appearance: 'none',
          '-webkit-appearance': 'none',
          '-moz-appearance': 'none',
          zIndex: 1,
        }
      }
    }),
    dropdownToggle: style({
      transform: 'rotate(90deg)',
      margin: '0 0 0 0.75rem'
    }),
  }
}